import { PhasrBehavioralProfilesComponent } from './component/PhasrBehavioralProfilesComponent';
import { WEB_COMPONENT_PHASR_BEHAVIORAL_PROFILES_RESTRICT } from '../../webcomponents.constants';

export { PhasrBehavioralProfilesComponent };

window.customElements.define(WEB_COMPONENT_PHASR_BEHAVIORAL_PROFILES_RESTRICT, PhasrBehavioralProfilesComponent);
